import { useAuth } from 'contexts/auth';
import InstructorAssignmentsPage from 'pages/InstructorAssignments';

const AssignmentsPage = () => {
    const { auth } = useAuth();
    if (auth.role === 'instructor') return <InstructorAssignmentsPage />;
    return null;
};

export default AssignmentsPage;
